<div class="flex w-72 items-center justify-between p-2">
  <!-- "previous" buttons -->
  <button mat-icon-button (click)="previousYearClicked()">
    <mat-icon svgIcon="heroicons_solid:chevron-double-left"></mat-icon>
  </button>
  <button mat-icon-button (click)="previousMonthClicked()">
    <mat-icon svgIcon="heroicons_solid:chevron-left"></mat-icon>
  </button>

  <!-- center label -->
  <span class="filter-date-header-label min-w-fit">{{ periodLabel }}</span>

  <!-- "next" buttons -->
  <button mat-icon-button (click)="nextMonthClicked()">
    <mat-icon svgIcon="heroicons_solid:chevron-right"></mat-icon>
  </button>
  <button mat-icon-button (click)="nextYearClicked()">
    <mat-icon svgIcon="heroicons_solid:chevron-double-right"></mat-icon>
  </button>
</div>
